import { Alert } from 'antd';
import React from 'react';

export interface IUserLoginErrorAlertProps {
  message: string | null | undefined;
}

export function UserLoginErrorAlert(props: IUserLoginErrorAlertProps) {
  const { message } = props;

  if (!message || message.length == 0) return null;

  return (
    <Alert
      message="Errore"
      description={message}
      type="error"
      showIcon
      closable
    />
  );
}
